import localScaleManager from "../../../../helpers/LocalScaleManager";

export class RaiseInput extends Phaser.GameObjects.Image {
  constructor(scene, parent, table) {
    super(scene, 0, 0, scene.atlasTexture, "raise-input-bg");
    this.scene = scene;
    this.parent = parent;
    this.table = table;
    this.scene.add.existing(this);
    this.table.poolArray.push(this);

    this.setOrigin(0);
    this.inputDomId = `NumberInput${new Date().valueOf()}`;
    this.inputText = this.scene.add
      .rexInputText(0, 0, 0, 0, {
        id: this.inputDomId,
        type: "string",
        text: this.parent.minRaise,
        fontSize: "10px",
        // backgroundImage: 'src/game/rawAssets/loading.png',
        // color: 'black',
        color: "white",
        fontFamily: "HelveticaNeue",
        textAlign: "center",
      })
      .setOrigin(0)
      .on("textchange", (inputText, text) => {
        // inputText.text = this.getCorrectInputValue(text.target.value) ;
        // inputText.text = this.getCorrectInputValue(text.target.value) ;
        // console.log(this.getCorrectInputValue(text.target.value));
        parent.inputValue = this.getCorrectInputValue(text.target.value);
        if (inputText.text)
          parent.menuWheel.fillByAmount(
            this.getCorrectInputValue(text.target.value)
          );
        inputText.text = this.toCurrency(text.target.value);
      });
    this.addStyleForRemoveNumberInputArrows();
    this.table.poolArray.push(this.inputText);
  }
  addStyleForRemoveNumberInputArrows() {
    let style = document.createElement("style");
    style.innerHTML = `
        #${this.inputDomId}::-webkit-inner-spin-button, 
        #${this.inputDomId}::-webkit-outer-spin-button { 
          -webkit-appearance: none; 
          margin: 0; 
        }`;
    document.head.appendChild(style);
  }
  setValue(value) {
    if (value - this.parent.playerBet === this.parent.userBalance) {
      this.inputText.setText("All-in");
    } else
      this.inputText.setText(
        this.getCorrectInputValue("" + value).toLocaleString()
      );
    this.parent.inputValue = this.getCorrectInputValue("" + value);
  }

  /**
   * @param string {string}
   * @return {number|*}
   */
  getCorrectInputValue(string) {
    let value = this.toNumber(string);
    if (value >= this.parent.minRaise && value <= this.parent.maxRaise) {
      return value;
    } else {
      if (value < this.parent.minRaise) {
        return this.parent.minRaise;
      } else if (value > this.parent.maxRaise) {
        return this.parent.maxRaise;
      }
    }
  }

  /***
   * @param string {string}
   * @return {string}
   */
  toCurrency(string) {
    if (!string) return "0";
    const pureNumbers = this.replaceAll(string, ",", "");
    return isNaN(+pureNumbers) ? "0" : (+pureNumbers).toLocaleString();
  }

  /**
   * @param string {string}
   * @return {number}
   */
  toNumber(string) {
    if (typeof string !== "string") string += "";
    const pureNumbers = this.replaceAll(string, ",", "");
    return isNaN(+pureNumbers) ? 0 : +pureNumbers;
  }
  /**
   * @param str {string}
   * @param searchValue {string}
   * @param replaceValue {string}
   * @return {string}
   */
  replaceAll(str, searchValue, replaceValue) {
    let preparedStr = "";
    for (let i = 0; i < str.length; i++) {
      preparedStr = preparedStr.concat(
        str[i] === searchValue ? replaceValue : str[i]
      );
    }
    return preparedStr;
  }
  /**
   *
   * @param width -> raise menu display width
   * @param height -> raise menu display height
   * @param initX -> raise menu x
   * @param initY -> raise menu y
   */
  positionControls(width, height, initX, initY) {
    let inputBgSize = width * 1.3;
    localScaleManager.scaleSprite(this, inputBgSize, inputBgSize, 0, 1, true);
    this.setPosition(
      initX + (width - this.displayWidth) / 2,
      initY - this.displayHeight * 1.7
    );
    this.inputText.resize(this.displayWidth, this.displayHeight);
    this.inputText.setStyle("fontSize", `${this.displayHeight * 0.7}px`);
    this.inputText.setStyle("paddingLeft", `${this.displayWidth * 0.06}px`);
    this.inputText.setPosition(
      initX + (width - this.displayWidth) / 2,
      initY - this.displayHeight * 1.7
    );
  }
  /**
   *
   * @param width -> raise menu display width
   * @param height -> raise menu display height
   * @param initX -> raise menu x
   * @param initY -> raise menu y
   */
  reposition(width, height, initX, initY) {
    this.setPosition(
      initX + (width - this.displayWidth) / 2,
      initY - this.displayHeight * 1.7
    );
    this.inputText.resize(this.displayWidth, this.displayHeight);
    this.inputText.setPosition(
      initX + (width - this.displayWidth) / 2,
      initY - this.displayHeight * 1.7
    );
  }

  remove() {
    this.destroy();
    this.inputText.destroy();
  }
}
